import type {
  PayloadAction,
  ReducersMapObject,
  ThunkDispatch,
  UnknownAction,
} from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import {
  type TypedUseSelectorHook,
  useDispatch,
  useSelector,
} from "react-redux";

type SliceDisplayState = {
  fullWidth: boolean;
};

const initialState: SliceDisplayState = {
  fullWidth: false,
};

const slice = createSlice({
  name: "display",
  initialState,
  reducers: {
    setSliceDisplayFullWidth: (draft, action: PayloadAction<boolean>) => {
      draft.fullWidth = action.payload;
    },
  },
});

type ReduxState = {
  display: SliceDisplayState;
};
type ReduxDispatch = ThunkDispatch<ReduxState, undefined, UnknownAction>;
type ReduxReducer = ReducersMapObject<ReduxState, UnknownAction, ReduxState>;

export const { setSliceDisplayFullWidth } = slice.actions;
export const storeReducerDisplay: ReduxReducer = {
  display: slice.reducer,
};

export const useDispatchDisplay: () => ReduxDispatch = useDispatch;
export const useSelectorDisplay: TypedUseSelectorHook<ReduxState> = useSelector;
